import React from "react";

interface HomepageSectionSkeletonProps {
  title?: string;
  itemCount?: number;
  className?: string;
}

/**
 * Skeleton loader for homepage sections
 * Provides progressive loading UI feedback
 */
export default function HomepageSectionSkeleton({
  title,
  itemCount = 4,
  className = "",
}: HomepageSectionSkeletonProps) {
  return (
    <div className={`w-full max-w-7xl mb-12 ${className}`}>
      {title && (
        <div className="h-8 bg-tertiary rounded w-1/4 mb-6 animate-pulse" />
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(itemCount)].map((_, index) => (
          <div key={index} className="space-y-4 animate-pulse">
            <div className="h-48 bg-tertiary rounded" />
            <div className="h-4 bg-tertiary rounded w-3/4" />
            <div className="h-4 bg-tertiary rounded w-1/2" />
          </div>
        ))}
      </div>
    </div>
  );
}
